import { render } from "./AppMobile.vue?vue&type=template&id=24c97f4f"
import script from "./AppMobile.vue?vue&type=script&lang=js"
export * from "./AppMobile.vue?vue&type=script&lang=js"

import "./AppMobile.vue?vue&type=style&index=0&id=24c97f4f&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__